import {
  Popover as MantinePopover,
  PopoverProps as MantinePopoverProps,
} from '@mantine/core';

import styles from './Popover.module.css';

export type PopoverProps = Omit<MantinePopoverProps, 'classNames' | 'styles'>;

const MIN_ARROW_OFFSET = 4;

export function Popover({
  withArrow = false,
  arrowSize = 14,
  offset,
  position = 'bottom-end',
  children,
  ...props
}: PopoverProps) {
  const resolvedOffset = offset ?? (withArrow ? MIN_ARROW_OFFSET : 0);

  return (
    <MantinePopover
      unstyled
      withArrow={withArrow}
      arrowSize={arrowSize}
      offset={resolvedOffset}
      position={position}
      classNames={{
        dropdown: styles.dropdown,
        arrow: styles.arrow,
      }}
      {...props}
    >
      {children}
    </MantinePopover>
  );
}

Popover.Dropdown = MantinePopover.Dropdown;
Popover.Target = MantinePopover.Target;
